import { useAppDispatch, useAppSelector } from "@/app/store/hooks";
import { selectAllProjects } from "@/entities/projects/model/selects";
import type { ProjectsType } from "@/entities/projects/model/types";
import { selectMapFilterData } from "@/features/map_filter/model/selects";
import { MapFilter } from "@/features/map_filter/ui";
import Button from "@/shared/ui/buttons/Button";
import { SectionLayout } from "@/shared/ui/layouts/SectionLayout";
import Typography from "@/shared/ui/Typography";
import { Map } from "@/widgets/map/ui/Map";
import { requestFormModalOpen } from "@/widgets/modal/model/slice";
import { useMemo } from "react";

export function MapSection() {
    const projects = useAppSelector(selectAllProjects);
    const filterData = useAppSelector(selectMapFilterData);

    const dispatch = useAppDispatch();
    
    const handleFindYourProperty = () => {
        dispatch(
            requestFormModalOpen({
                title: 'Записаться на консультацию',
                text: 'Наш эксперт свяжется с вами в ближайшее время, чтобы подобрать подходящую недвижимость или ответить на интересующие вопросы',
            })
        );
    };

    const filteredData: ProjectsType = useMemo(() => {
        if (!projects) return [];

        const { apartment, price, districtId } = filterData;

        return projects.filter((project) => {
            if (apartment !== null && !project.rooms.includes(apartment)) {
                return false;
            }

            if (price !== null && project.priceFrom < price) {
                return false;
            }

            if (
                districtId !== null &&
                project.location.districtId !== districtId
            ) {
                return false;
            }

            return true;
        });
    }, [projects, filterData]);

    return (
        <SectionLayout
            className=""
            containerClassName="relative flex flex-col pt-[52px] gap-[16px] md:gap-[20px]"
        >
            <div className="flex flex-col gap-[20px] md:gap-[28px]">
                <Typography tag="h2" className="text-center">
                    Недвижимость в Санкт-Петербурге
                </Typography>
                <div className="w-full flex flex-col items-center gap-[12px] md:gap-[20px] lg:flex-row">
                    <MapFilter />

                    <Button
                        iconType="search"
                        className="bg-white-50 text-blue w-fit whitespace-nowrap transition-colors duration-300 ease-in-out origin-left hover:text-white hover:bg-blue"
                        onClick={handleFindYourProperty}
                    >
                        Найти свою недвижимость
                    </Button>
                </div>
            </div>

            <Map projects={filteredData || []} />
        </SectionLayout>
    );
}
